<template>
  <div class="charts">
    <donut-chart
      class="donut"
      v-if="qty_project_statuses"
      title="Qty. Projects by Statuses"
      :data="qty_project_statuses"
      @filter="setStatusFilter"
    />
    <donut-chart
      class="donut"
      v-if="qty_project_categories"
      title="Qty. Projects by Team"
      :data="qty_project_categories"
      @filter="setCategoryFilter"
    />
    <donut-chart
      class="donut"
      v-if="qty_project_types"
      title="Qty. Projects by Types"
      :data="qty_project_types"
      @filter="setTypeFilter"
    />
  </div>
</template>

<script>
import DonutChart from '../charts/Donut';

export default {
  components: { DonutChart },
  data() {
    return {
      filter: {
        status: [],
        category: [],
        type: [],
      },
    };
  },
  props: ['data'],
  computed: {
    labels() {
      const labels = {
        statuses: new Set(),
        categories: new Set(),
        types: new Set(),
      };

      this.data.forEach(project => {
        project.status && labels.statuses.add(project.status);
        project.category && labels.categories.add(project.category);
        project.type && labels.types.add(project.type);
      });

      return labels;
    },
    qty_project_statuses() {
      const filter = data => {
        // Set the labels
        let filtered = Array.from(this.labels.statuses).reduce(
          (o, key) => ({ ...o, [key]: 0 }),
          {}
        );

        // Filter the data
        data
          .filter(
            el =>
              el['status'] !== null &&
              !this.filter.category.includes(el.category) &&
              !this.filter.type.includes(el.type)
          )
          .forEach(project => filtered[project.status]++);

        // Return a key value pair of labels and values
        return Object.keys(filtered).map(key => ({
          label: key,
          value: filtered[key],
        }));
      };

      return !this.data ? null : filter(this.data);
    },
    qty_project_categories() {
      const filter = data => {
        // Set the labels
        let filtered = Array.from(this.labels.categories).reduce(
          (o, key) => ({ ...o, [key]: 0 }),
          {}
        );

        // Filter the data
        data
          .filter(
            el =>
              el['category'] !== null &&
              !this.filter.status.includes(el.status) &&
              !this.filter.type.includes(el.type)
          )
          .forEach(project => filtered[project.category]++);

        // Return a key value pair of labels and values
        return Object.keys(filtered).map(key => ({
          label: key,
          value: filtered[key],
        }));
      };

      return !this.data ? null : filter(this.data);
    },
    qty_project_types() {
      const filter = data => {
        // Set the labels
        let filtered = Array.from(this.labels.types).reduce(
          (o, key) => ({ ...o, [key]: 0 }),
          {}
        );

        // Filter the data
        data
          .filter(
            el =>
              el['type'] !== null &&
              !this.filter.status.includes(el.status) &&
              !this.filter.category.includes(el.category)
          )
          .forEach(project => filtered[project.type]++);

        // Return a key value pair of labels and values
        return Object.keys(filtered).map(key => ({
          label: key,
          value: filtered[key],
        }));
      };

      return !this.data ? null : filter(this.data);
    },
  },
  methods: {
    setStatusFilter(value) {
      this.filter.status = value;
    },
    setCategoryFilter(value) {
      this.filter.category = value;
    },
    setTypeFilter(value) {
      this.filter.type = value;
    },
  },
};
</script>

<style scoped>
.charts {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.donut {
  width: 300px;
  height: 300px;
}
</style>
